import { ActionTree } from 'vuex'
import { ConsumingDeviceState } from './types';
import { RootState } from '@/store/types';

export const actions: ActionTree<ConsumingDeviceState, RootState> = {
}
